import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from '@emotion/styled';

import { getLineCodeInfo } from '../api/visitor';

import { LineCodeResponse } from '../types';

import smLinecodeViewBg from '../assets/smLinecodeViewBg.svg';
import smPoster from '../assets/smPoster.png';
import asset1 from '../assets/asset1.png';

const LineCodeView = () => {
  const { confirmCode } = useParams<{ confirmCode: string }>();
  const [data, setData] = useState<LineCodeResponse['data'] | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchLineCodeInfo = async () => {
      if (!confirmCode) {
        setError('ConfirmCode가 없습니다.');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const response = await getLineCodeInfo(confirmCode);

        if (response.success) {
          setData(response.data);
        } else {
          setError(response.message || '조회에 실패했습니다.');
        }
      } catch (error: any) {
        console.error('Line code fetch error: ', error);
        setError(error.response?.data?.message || '네트워크 오류가 발생했습니다.');
      } finally {
        setLoading(false);
      }
    };
    fetchLineCodeInfo();
  }, [confirmCode]);

  return (
    <>
      {loading && (
        <LoadingContainer>
          <div>정보를 불러오는 중...</div>
        </LoadingContainer>
      )}
      {!loading && error && (
        <ErrorContainer>
          <h2>오류 발생</h2>
          <p>{error}</p>
        </ErrorContainer>
      )}
      {!loading && !error && data && (
        <Container>
          <ContentWrapper>
            <LogoSection>
              <img src={smPoster} alt="STARTUP INSIDE 2025" />
            </LogoSection>
            <InfoSection>
              <h2>{data.visitor_company_name}</h2>
              <h2>{data.visitor_position}</h2>
              <p>{data.visitor_name}</p>
            </InfoSection>

            <ButtonSection>
              <a
                href="https://drive.google.com/drive/folders/19hE0WkRNacOTDhrMY-V6qRBSQSlLYosM"
                style={{ textDecorationLine: 'none' }}
              >
                <TextButton
                // onClick={() => {
                //   console.log('기업 IR 보기 클릭');
                //   // window.open('https://drive.google.com/drive/folders/19hE0WkRNacOTDhrMY-V6qRBSQSlLYosM', '_blank');

                // }}
                >
                  <img src={asset1} alt="" />
                  <span>기업 IR 보기</span>
                </TextButton>
              </a>
            </ButtonSection>
          </ContentWrapper>
        </Container>
      )}
    </>
  );
};

export default LineCodeView;

const Container = styled.div`
  min-height: 100vh;
  background-image: url(${smLinecodeViewBg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 20px;
`;

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 500px;
  text-align: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const LogoSection = styled.div`
  margin-top: 80px;
  margin-bottom: 40px;
  text-align: center;

  img {
    width: 100px;
    height: auto;
  }
`;

const InfoSection = styled.div`
  margin-bottom: 10px;

  h2 {
    color: #ffffff;
    font-size: 28px;
    margin-bottom: 15px;
    font-weight: 600;
  }

  p {
    color: #ffffff;
    font-size: 34px;
    margin: 10px 0;
    font-weight: 600;
  }
`;

const ButtonSection = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 5px;
`;

const TextButton = styled.button`
  background: transparent;
  border: 2px solid #ffffff;
  border-radius: 30px;
  color: #ffffff;
  padding: 12px 50px;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  img {
    width: 20px;
    height: 20px;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

const LoadingContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-size: 20px;
`;

const ErrorContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;

  h2 {
    font-size: 24px;
    margin-bottom: 20px;
  }

  p {
    font-size: 18px;
    opacity: 0.8;
  }
`;

const BottomBranding = styled.div`
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 30px;

  .urcode-logo {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #ffffff;
    font-size: 20px;
    font-weight: bold;
  }

  .phone-image {
    width: 180px;
    height: auto;
  }
`;
